export default __webpack_public_path__ + "static/media/image-ph-health-briefing-m@2x.d68bf890.png";